import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 51
class PrintReportSummaryFixingWork extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],work_state:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined) {
            ReportStore.loadReportKpiJobControl(this.props.year,this.props.month,this.props.day,(result)=>{
                this.setState({work_state:result.work_state,data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined) {
            ReportStore.loadReportKpiJobControlRange(this.props.startDate,this.props.endDate,(result)=>{
                this.setState({work_state:result.work_state,data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({work_state:[],data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value,digit=2) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        let {work_state} = this.state
        if (data.length==0) {
            return(<tr><td colSpan={(work_state.length*1)+6}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
                <td className='text-center'>{item.work_date}</td>
                <td className='text-center'>{item.appointment_date}</td>
                <td className='text-center'>{item.delivering_date}</td>
                <td className='text-center'>{item.work_no}</td>
                <td className='text-center'>{item.car_registration_no}</td>
                {work_state.map((sitem,sindex)=>{
                    return(
                        <td key={sindex} className='text-center'>{this.getNumberFormat(item[sitem.value],0)}</td>
                    )
                })}
                <td className='text-center'>{this.getNumberFormat(item.total_man_hour,0)}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        // let {type} = this.props
        let {work_state} = this.state
        return(
            <table className='table table-print-report-fixing'>
                <tbody>
                    <tr>
                        <td style={{width:'100px'}} className='text-center'>วันที่เข้าระบบ</td>
                        <td style={{width:'100px'}} className='text-center'>วันที่นัดหมาย</td>
                        <td style={{width:'100px'}} className='text-center'>วันที่ส่งมอบ</td>
                        <td style={{width:'120px'}} className='text-center'>เลขงานซ่อม</td>
                        <td style={{width:'100px'}} className='text-center'>เลขทะเบียน</td>
                        {work_state.map((item,index)=>{
                            return(
                                <td key={index} style={{width:'70px'}} className='text-center'>{item.label}</td>
                            )
                        })}
                        <td style={{width:'100px'}} className='text-center'>เวลารวม</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    <tr>
                        <td colSpan={5} className='text-right'>ยอดรวมสุทธิ</td>
                        {work_state.map((item,index)=>{
                            return(
                                <td key={index} className='text-center'>{this.getNumberFormat(this.getSummary(item.value),0)}</td>
                            )
                        })}
                        <td className='text-center'>{this.getNumberFormat(this.getSummary('total_man_hour'),0)}</td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportSummaryFixingWork.defaultProps = {
    title: 'ตารางรายงานสรุประยะเวลางานซ่อมของรถแต่ละคัน',
    mode: '',
    workNo: ''
  }
  export default PrintReportSummaryFixingWork;


// WEBPACK FOOTER //
// ./src/view/print/fixing/PrintReportSummaryFixingWork.js